import React from "react";
import ProfilesContainer from "../containers/ProfilesContainer";

export const ProfilesPage: React.FunctionComponent = () => <ProfilesContainer />;